import { memo } from "react"
import { Script } from "gatsby"
import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react"
import config from "@root/config.js"

const EmbedForm: React.FC<GatsbyTypes.SanitySectionEmbedForm> = ({ bgColor, title, subtitle, content, embedFormId }) => {
  const hasForm = !!embedFormId?.length
  if (!hasForm) return null

  const klaviyoApiKey = config.store.klaviyoApiKey

  return (
    <>
      <Script src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoApiKey}`} strategy="post-hydrate" />
      <Box as="section" bg={bgColor} pt={[12, 12, 18]} pb={[14, 14, 12]}>
        <Container>
          <Flex w="full" alignItems={["center"]} justifyContent={["space-between"]} gap={[2, 6, 8]} flexDirection={["column", "row"]}>
            <Box py={[2, 8]} w={["100%", "50%"]} flexGrow={1}>
              {subtitle && (
                <Text color="brand.avocado" mb={4}>
                  {subtitle}
                </Text>
              )}
              {title && (
                <Heading as="h3" size="h2" color="brand.avocado" maxW="550px" mb={[4, 4, 6]}>
                  {title}
                </Heading>
              )}
            </Box>
            <Box py={[2, 8]} w={["100%", "50%"]} flexGrow={1}>
              {content && (
                <Text color="brand.avocado" mb={4}>
                  {content}
                </Text>
              )}
              <Box as="div" className={`${embedFormId}`}></Box>
            </Box>
          </Flex>
        </Container>
      </Box>
    </>
  )
}

export default memo(EmbedForm)
